export default function PageShell({ title, subtitle, kicker, actions, children }) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 dark:from-slate-900 via-indigo-50/40 dark:via-indigo-950/40 to-sky-50 dark:to-sky-950/40 text-slate-900 dark:text-slate-100 relative">
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -top-24 -left-32 h-[420px] w-[420px] rounded-full bg-indigo-200/35 blur-3xl" />
        <div className="absolute top-10 -right-36 h-[460px] w-[460px] rounded-full bg-sky-200/30 blur-3xl" />
        <div className="absolute bottom-[-180px] left-1/3 h-[520px] w-[520px] rounded-full bg-amber-200/25 blur-3xl" />
      </div>
      <main className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {(title || subtitle || kicker || actions) && (
          <div className="flex flex-wrap items-start justify-between gap-4 mb-6">
            <div>
              {kicker && <p className="text-sm text-indigo-700 dark:text-indigo-300 font-semibold">{kicker}</p>}
              {title && <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900 dark:text-slate-100">{title}</h1>}
              {subtitle && <p className="text-slate-600 dark:text-slate-400">{subtitle}</p>}
            </div>
            {actions ? <div className="flex max-w-full flex-wrap gap-2 sm:shrink-0">{actions}</div> : null}
          </div>
        )}
        {children}
      </main>
    </div>
  );
}
